export default __webpack_public_path__ + "static/media/xk.6555b425.svg";